const injuryprevention = {
    title: "Injury Prevention",
    mdcontent: `
    
## Injury Prevention

As discussed throughout, safe and correct execution of skills and techniques are some of the most important elements of hockey development. This will not only enable players to perform skills correctly, but also act as a preventative measure to injuries.
\n
- **The three key principles for teams to remember are**:
    - Good level and technique of foundation skills (skating, balance, coordination, awareness, strength).
    - Teaching safe and proper use of contact tactics.
    - Enforcement of rules and adherence to rules.

To enhance injury prevention teams are encouraged to use a **medical form** which is downloadable [here](https://buiha.org.uk/assets/img/education/PlayerHealthForm.pdf). These should be distributed each season and kept in a secure and confidential location, however accessible at training and games in case of emergencies. Knowing medication and illnesses alongside serious previous injury are important as they may predispose players to further injury or be life-saving if an accident occurs.
\n
Previous recent and severe injuries are also important knowledge in planning training activities, lines, and help react in case of further injuries or incidences. 

## Warm Up

Proper preperation for training and competition is an important part of injury prevention. An example warm up guide has been produced by the BUIHA and is available for download [here](https://buiha.org.uk/assets/img/education/BUIHA-WarmUpGuide.pdf).

## Injury Reporting
Please report any injuries occurred during BUIHA training or games, including varsity, GBS and international All-Stars, in the Google Form found [here](https://forms.gle/xY9EYYWXbCp4aZEp8). 
**This will not collect any personal data or email address from which you could be identified.**

## Concussions

The latest BUIHA Injury Epidemiology study found the head as the most common injury location with overall injuries most frequently occurring from body-contact. Lack of prior contact skill education and ability to recognise illegal contact characteristics is also concerning.

Teams are recommended to use a Pocket Concussion Recognition Tool 5 (CRT5), which you can download [here](https://buiha.org.uk/assets/img/education/PocketConcussionRecognitionTool5.pdf). It is a on-ice tool designed for non-healthcare professionals, such as coaches, to recognise early signs of suspected concussion and decide removal of play (Echemendia, et al. 2017).

In any case of suspected concussion, players should always be removed from play and directed for further medical examination. Playing with a concussion should never be encouraged as it predisposes the players brain to further injury

**For further information on head injury and concussion symptoms, please visit the [NHS website](https://www.nhs.uk/conditions/head-injury-and-concussion/).**

`,
    };
export default injuryprevention;